import { Injectable, computed, signal } from "@angular/core";
import { CommonService } from "../common/common.service";
import { ChargeFrequencyEnum, CompanyIdEnum } from "../domain/enums";
import { ICampaignBindingModel, IHospitalBindingModel, IRadioStationNameBindingModel } from "../domain/types";

@Injectable({
  providedIn: "root",
})
export class CsrService {
  bindGiftToInHonorInMemory() {
    throw new Error("Method not implemented.");
  }
  private _hospitalName = "";
  public donorFirstName = "";
  public donorLastName = "";
  public donorId = 0;
  public donorReferenceNumber;
  public donorSeed;
  public responseMsg: string;
  public processRefNo: string;
  public authCode: string;
  public resultCode = -1;
  public initialized = false;
  public donationAmount = 0;
  public chargeFrequency = ChargeFrequencyEnum.OneTime;
  
  campaign = signal<ICampaignBindingModel>(null);
  campaignId = signal<string>("");
  campaignImageUrl = signal<string>("");
  hospital = signal<IHospitalBindingModel>(null);
  hospitalId = signal<string>("");
  radioStation = signal<IRadioStationNameBindingModel>(null);
  radioStationId = signal<string>("");
  donationEnabled = signal<boolean>(true);

  public allowLegacyUrlFormat = false;
  

  donorTransactionId: number;

  constructor(
    private _commonService: CommonService
  ) {}

  public initialize() {
    this._hospitalName = "";
    this.donorFirstName = "";
    this.donorLastName = "";
    this.donorId = 0;
    this.donationAmount = 0;
    this.chargeFrequency = ChargeFrequencyEnum.OneTime;
    this.resultCode = -1;
    this._hospitalName = "";
    this._commonService.saveSelectedMarketId(null);
    this.donationEnabled.set(true);
    this.initialized = true;
  }
  
  setCampaignId(id: string | null) {
    this.campaignId.set(id);
  }

  setHospitalId(id: string | null) {
    this.hospitalId.set(id);
  }

  getHospitalName(): string {
    return this._hospitalName;
  }

  setHospitalName(name: string) {
    this._hospitalName = name;
  }

  public validateId(id: string, keyName: string): string {
    if (!id) 
      throw new Error("Invalid " + keyName + " format");

    // validate URL-safe characters to prevent XSS vulnerabilities
    if (!this.isUrlSafe(id)) {
      throw new Error("Invalid " + keyName + " format - contains unsafe characters");
    }

    // If legacy URLs are enabled, accept any URL-safe ID format
    if (this.allowLegacyUrlFormat) {
      return id;
    }
    
    // If legacy URLs are disabled, only accept hashed IDs
    if (this.isHashedId(id)) {
      return id;
    } else {
      throw new Error("Invalid " + keyName + " format");
    }
  }

  private isHashedId(id: string | null): boolean {
    if (!id) return false;
    
    // Check if it's a numeric ID (actual) or alphanumeric (hashed)
    return !/^\d+$/.test(id);
  }

  private isUrlSafe(str: string): boolean {
    const alphanumericPattern = /^[a-zA-Z0-9]+$/;
    return alphanumericPattern.test(str);
  }

  readonly campaignBrandingContext = computed((): {
    campaignId: number | null;
    companyId: number | null;
    companyName: string | null;
    campaignTypeId: number | null;
    campaignType: string | null;
  } => {
    const campaign = this.campaign();

    if (!campaign) {
      return {
        campaignId: null,
        companyId: null,
        companyName: null,
        campaignTypeId: null,
        campaignType: null,
      };
    }

    return {
      campaignId: campaign.campaignId ?? null,
      companyId: campaign.companyId ?? null,
      companyName: campaign.companyName ?? campaign.foundationName ?? null,
      campaignTypeId: campaign.campaignTypeId ?? null,
      campaignType: campaign.campaignType ?? null,
    };
  });

  readonly isCmnCampaign = computed((): boolean => {
    const campaign = this.campaign();
    return campaign?.activeYn === true && campaign.companyId === CompanyIdEnum.CMN;
  });

}
